export enum BookingEnginePaymentCardRequirement {
    AlwaysRequired = 'AlwaysRequired',
    NotRequired = 'NotRequired',
    NotRequiredForFullyOrPartiallyPaidBookings = 'NotRequiredForFullyOrPartiallyPaidBookings',
    NotRequiredForFullyPaidBookings = 'NotRequiredForFullyPaidBookings',
}
